export default __webpack_public_path__ + "static/media/ortopedia.c3813678.jpg";